import { PredicateIconClassNames } from './predicate-icon-classnames';

const getIconClassNames = () => {
  const labelsCellMCC = `& .${PredicateIconClassNames.LabelsCellMCC}`;
  const labelsCellAccount = `& .${PredicateIconClassNames.LabelsCellAccount}`;

  const iconClassNames = {};
  iconClassNames[labelsCellMCC] = {
    '&::before': {
      content: '"\\ECA6"',
      fontSize: '12px',
    },
  };

  iconClassNames[labelsCellAccount] = {
    '&::before': {
      content: '"\\EFBE"',
      fontSize: '12px',
    },
  };

  return iconClassNames;
};

export const getHumanizedPredicateStyles = () => ({
  humanizedPredicateIcon: {
    display: 'inline-block',
    fontFamily: 'MsAds MDL2 Assets',
    marginLeft: '5px',
    transform: 'translateY(1px)',

    ...getIconClassNames(),
  },
});
